import { useMemo, useState } from 'react';
import dayjs from 'dayjs';
import useApiResult from './useApiResult';
import {
  getUserNextAvailableAppointment,
  postUserNextAvailableAppointment,
} from '../promises/getUserNextAvailableAppointment';

function useUserNextAvailableAppointment() {
  const todaysDate = dayjs().toDate();
  const [triggerCounter, setTriggerCounter] = useState(0);
  const userNextAvailableAppointmentResults = useMemo(
    () => getUserNextAvailableAppointment(todaysDate),
    [triggerCounter]
  );
  const { loading, error, result } = useApiResult(
    userNextAvailableAppointmentResults
  );

  function refetch() {
    setTriggerCounter((prev) => prev + 1);
  }

  async function addUserNextAvailableAppointment(
    nextAvailableAppointmentId: number
  ) {
    try {
      await postUserNextAvailableAppointment(
        todaysDate,
        nextAvailableAppointmentId
      );
    } catch (e) {
      console.error(e);
    }
  }

  return {
    loading,
    error,
    nextAvailableAppointment: result,
    addUserNextAvailableAppointment,
    refetch,
  };
}

export default useUserNextAvailableAppointment;
